import { render, staticRenderFns } from "./CrmEditExtraFields.vue?vue&type=template&id=5e3fc5c2"
import script from "./CrmEditExtraFields.vue?vue&type=script&lang=ts"
export * from "./CrmEditExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3fc5c2')) {
      api.createRecord('5e3fc5c2', component.options)
    } else {
      api.reload('5e3fc5c2', component.options)
    }
    module.hot.accept("./CrmEditExtraFields.vue?vue&type=template&id=5e3fc5c2", function () {
      api.rerender('5e3fc5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmEditExtraFields.vue"
export default component.exports